import { render } from "./UiDashboardLink.vue?vue&type=template&id=b064d90c&ts=true"
import script from "./UiDashboardLink.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiDashboardLink.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiDashboardLink.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b064d90c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b064d90c', __exports__)) {
    api.reload('b064d90c', __exports__)
  }
  
  module.hot.accept("./UiDashboardLink.vue?vue&type=template&id=b064d90c&ts=true", () => {
    api.rerender('b064d90c', render)
  })

}


export default __exports__